import { useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'

import {
  FaEnvelope,
  FaPhone,
  FaIdBadge,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaArrowLeft,
  FaHashtag,
} from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'
import ApiEndpoints, { BASE_URL_Upload } from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas'

export default function IDcard({ student }) {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const { id } = useParams()
  console.log('ID OF STD: ', id)
  const navigate = useNavigate()
  // const idCardRef = useRef(null)
  const frontRef = useRef()
  const backRef = useRef()

  const downloadAsJPG = async (element, filename) => {
    console.log('element', element)
    console.log('filename', filename)

    const canvas = await html2canvas(element, {
      backgroundColor: '#fff',
      useCORS: true,
      allowTaint: false,
      imageTimeout: 0,
    })
    const image = canvas.toDataURL('image/jpeg', 1.0)

    const link = document.createElement('a')
    link.href = image
    link.download = `${filename}.jpg`
    link.click()
  }

  const [data, setData] = useState('')
  console.log('data is define here', data)
  const [img, setImg] = useState(null)
  const [courses, setCourses] = useState([])
  console.log('COURSES: ', courses)
  const [classes, setClasses] = useState([])
  const [institutes, setInstitutes] = useState('')
  // const img = new Image()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const storedInstitute = Cookies.get('institute_name')
    if (storedInstitute) {
      setInstitutes(storedInstitute)
    }
  }, [])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
    ApiEndpoints.getAllClasses().then((res) => setClasses(res.data.data))
  }, [])

  useEffect(() => {
    if (!data?.institute_id) {
      console.log('No institute_id found in data')
      return
    }

    console.log('Fetching institutes for institute_id:', data.institute_id)

    ApiEndpoints.getAllInstitutes()
      .then((res) => {
        console.log('API Response:', res.data)

        if (Array.isArray(res.data.data)) {
          console.log('Institutes Array:', res.data.data)

          const studentInstitute = res.data.data.find(
            (inst) => inst.institute_id === data.institute_id, // Corrected
          )

          console.log('Matched studentInstitute:', studentInstitute)

          if (studentInstitute) {
            setInstitutes(studentInstitute)
          } else {
            console.log('No matching institute found, setting default')
            setInstitutes({ institute_name: 'Unknown Institute' })
          }
        } else {
          console.log('Invalid data format received:', res.data)
        }
      })
      .catch((error) => console.error('Error fetching institutes:', error))
  }, [data?.institute_id])

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        console.log('Fetching student data, ID:', id)

        if (!id) {
          console.warn('No ID provided')
          return
        }

        const response = await ApiEndpoints.viewProfile(id)
        if (response.data && response.data.data) {
          const studentData = response.data.data
          setData(studentData)
          setImg(studentData)
        } else {
          console.error('No data found for student ID:', id)
        }
      } catch (error) {
        console.error('Error while fetching student data:', error)
      } finally {
        setLoading(false) // 🛑 Important: Stop loading after everything
      }
    }

    fetchStudentData()
  }, [id])

  const handlePrint = () => {
    const printWindow = window.open('', '', 'width=1000,height=700')

    const frontCardHTML = document.querySelector('.front-card')?.outerHTML || ''
    const backCardHTML = document.querySelector('.back-card')?.outerHTML || ''

    printWindow.document.write(`
      <html>
        <head>
          <title>ID Card</title>

          <style>
  @page {
    // size: A5 portrait;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background: white;
  }

  .print-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: row;
    gap: 20px;
    padding: 10mm;
    box-sizing: border-box;
  }

  .page-break {
    page-break-after: always;
  }

  .card {
    width: 360px;
    height: 500px;
    // width: 86mm ;
    // height: 55mm ;
    border: .5px solid #000;
    border-radius: 15px;
    padding: 5px;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #fff;
  }

  .front-card, .back-card {
    box-shadow: none !important;
  }

  .institute-header {
    height: 67px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
    flex-direction: column !important;
  }
.inst-name{
    font-size:18px !important;
    margin-top:2px !important;
}
    .inst-about{
    font-size:15px !important;
  color: rgba(255, 255, 255, 0.6);
}
  .student-name {
    text-align: center !important;
    margin-top: .7rem !important;

  }
.student-bio {
  margin-left: 10px !important;
  color: #007bff;
}

.student-bio .bio-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 8px;
  gap:2px;
  color: #007bff;
}

.student-bio .bio-item svg {
  margin-bottom: 4px; /* Space between icon and text */
  color: #007bff;
  font-size: 18px;
}

.student-bio .bio-item p {
  margin: 0;
  font-size: 13px;
  color: #007bff;
}

  .stamp {
    display: flex !important;
    justify-content: center !important;
    margin-top: 1.8rem !important;
    // margin-bottom: -6px !important;
  }


.print-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem !important;
}

.print-image {
  width: 50px !important;
  height: 50px !important;
  border: 2px solid #007bff !important;
  background: white !important;
  object-fit: cover !important;
}

  h1, h2, h3, h4, h5, h6, p, span, strong {
    font-size: 15px !important;
    margin: 2px 0 !important;
  }

  .text-primary {
    color: #007bff !important;
  }

  .small {
    font-size: 13px !important;
  }

  .fw-bold {
    font-weight: bold;
  }

  .rounded-circle {
    border-radius: 50% !important;
  }

  // Back portion of ID Card
.inst-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // gap: 5px;
  // padding: 0 5px;
}

.inst-logo img {
  display: block;
  margin: 0 auto;
  max-width:80% !important;
}

.inst-info {
  text-align: center;
  flex: 1;
  letter-spacing:2px !important;
    font-size: 19px;
  margin-top: 0rem;
}

.ins-card{
  margin-top: 2rem;
}
.inst-data {
  flex: 2;
  text-align: start;
  padding: 0 5px;
  color: #6c757d !important;
  margin-bottom: 2rem;

}
.inst-data p {
  font-size: 16px !important;
}

.inst-location {
  margin-left: 20px !important;
  font-size: 15px;
}

</style>

        </head>
        <body>
          <div class="print-container page-break">
            ${frontCardHTML}
          </div>
          <div class="print-container">
            ${backCardHTML}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `)

    printWindow.document.close()
    printWindow.focus()
  }

  const handleDownloadBoth = () => {
    if (frontRef.current && backRef.current) {
      downloadAsJPG(frontRef.current, 'ID_Card_Front')
      downloadAsJPG(backRef.current, 'ID_Card_Back')
    }
  }
  // const handleDownloadPDF = () => {
  //   const element = document.getElementById('print-idcard')
  //   html2pdf()
  //     .from(element)
  //     .set({
  //       margin: 0,
  //       filename: `${data?.name || 'id_card'}.pdf`,
  //       html2canvas: { scale: 4 },
  //       jsPDF: { orientation: 'landscape', unit: 'mm', format: 'a5' },
  //     })
  //     .save()
  // }

  const handleBack = () => {
    navigate('/AddStudent')
  }
  const handleStudentProfile = () => {
    navigate(`/StudentProfile/${id}`)
  }
  return (
    <>
      <style>
        {`
         @media (max-width: 767.98px) {
          .responsive-btn {
            margin-top:5px !important;
            padding: 0.25rem 0.5rem !important;
            font-size: 0.875rem !important; /* equivalent to btn-sm */
          }
        }
        @media (max-width: 767.98px) {
          .responsive-btn {
            // padding: 0.25rem 0.5rem !important;
            // font-size: 0.87rem !important;
          }
          .card-id-container{
           margin-top: 4rem !important ;
           margin-left:9rem !important;
           max-width:10% !important;
          }
          .inst-name,
          .inst-about {
            font-size: 0.8rem !important;
            text-align: center;
          }

          .student-name h6 {
            font-size: 1rem !important;
          }
        }

        `}
      </style>
      <div style={{ marginLeft }}>
        {data ? (
          <>
            <div
              className="container-fluid "
              style={{
                marginTop: window.innerWidth < 768 ? '55px' : '-12px',
              }}
            >
              <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white me-auto">
                <div className="m-0">
                  <h2 className="mb-0">
                    <span className="text-warning">{data.name}</span>'s ID Card
                  </h2>
                </div>
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-light"
                    className="border-white responsive-btn"
                    onClick={handleStudentProfile}
                  >
                    Go to {data.name} Profile
                  </Button>
                  <Button
                    variant="outline-light"
                    className="border-white responsive-btn"
                    onClick={handleBack}
                  >
                    <FaArrowLeft /> Go to Student List
                  </Button>
                </div>
              </div>
            </div>

            <div
              id="print-idcard"
              // style={{ marginTop: '-3rem' }}
              class="printable-section "
            >
              <Container
                className="d-flex justify-content-center align-items-center vh-75 card-id-container"
                style={{ minHeight: '65vh' }}
              >
                <Row className="justify-content-center">
                  {/* Front Side of ID Card */}
                  {/* <Col>
                    <Card
                      ref={frontRef}
                      className="p-3 shadow border border-2 text-center position-relative front-card"
                      style={{
                        width: '360px',
                        height: '500px',
                        borderRadius: '15px',
                        overflow: 'hidden',
                      }}
                    > */}
                  <Col
                    xs={12}
                    md={6}
                    className="d-flex justify-content-center mb-4"
                  >
                    <Card
                      style={{
                        width: '100%',
                        maxWidth: '360px',
                        height: '500px',
                        borderRadius: '15px',
                        overflow: 'hidden',
                      }}
                      className="p-3 shadow border border-2 text-center position-relative front-card"
                      ref={frontRef}
                    >
                      <div
                        className="py-2 institute-header"
                        style={{
                          background: '#007bff',
                          color: 'white',
                          borderTopLeftRadius: '12px',
                          borderTopRightRadius: '12px',
                          fontWeight: 'bold',
                          letterSpacing: '1px',
                          WebkitPrintColorAdjust: 'exact',
                          printColorAdjust: 'exact',
                          // height: '80px',
                        }}
                      >
                        <h6 className="m-0 inst-name">
                          {institutes?.name || 'Institute Management'}{' '}
                        </h6>
                        <p className="m-0 text-white-50 small inst-about">
                          Education for Excellence
                        </p>
                      </div>

                      <Card.Body
                        className="p-2 position-relative"
                        style={{ zIndex: 2 }}
                      >
                        {/* Profile Image */}
                        <div className="print-image-wrapper d-flex justify-content-center my-2">
                          <Image
                            className="img-style"
                            src={
                              img?.student_image
                                ? img.student_image.replace(
                                    BASE_URL_Upload + '/storage/student/',
                                    BASE_URL_Upload + '/student/images/student/',
                                  )
                                : '/studentprofile.jpg'
                            }
                            style={{
                              width: '90px',
                              height: '90px',
                              border: '3px solid #007bff',
                              background: 'white',
                            }}
                            onLoad={() => console.log('Image loaded')}
                          />
                        </div>

                        {/* Student Details */}
                        <div className="student-name fw-bold">
                          <h6 className="fw-bold text-dark">
                            {data?.name.toUpperCase() || 'N/A'}
                          </h6>
                          <p className="text-muted small m-0">
                            Session : 2025 - 26
                          </p>
                        </div>
                        <hr className="mt-2 mb-2" />

                        <Row className="text-start ps-3 student-bio fw-bold">
                          <Col
                            xs={12}
                            className="d-flex align-items-center text-primary fs-6 mt-2 bio-item"
                          >
                            <FaIdBadge className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>ID:</strong>{' '}
                              {data?.admission_number || ''}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            className="d-flex align-items-center text-primary fs-6 mt-2 bio-item"
                          >
                            <FaCalendarAlt className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Join:</strong>{' '}
                              {data?.created_at
                                ? new Date(data.created_at).toLocaleDateString(
                                    'en-GB',
                                    {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric',
                                    },
                                  )
                                : null}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            className="d-flex align-items-center text-primary fs-6 mt-2 bio-item"
                          >
                            <FaEnvelope className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Email:</strong> {data?.email || ''}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            className="d-flex align-items-center text-primary fs-6 mt-2 bio-item"
                          >
                            <FaPhone className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Phone:</strong> +91 {data?.phone || ''}
                            </p>
                          </Col>
                        </Row>

                        <hr className="mt-2 mb-4 mt-2" />
                        {/* Director Signature */}
                        <div className="text-center mt-2 stamp">
                          {/* <FaSignature size={25} className="text-muted" /> */}
                          <Image
                            src="/stamp.jpg"
                            alt="stamp"
                            style={{
                              width: '90px',
                              height: '90px',
                              marginTop: '-1.15rem',
                            }}
                            roundedCircle
                          />
                          {/* <p className="fw-bold m-0 small">
                          Director's Signature
                        </p> */}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  {/* Back Side of ID Card */}
                  <Col>
                    <Card
                      ref={backRef}
                      className="p-3 shadow border border-2 text-center position-relative back-card"
                      style={{
                        // width: '86mm',
                        // height: '55mm',
                        // borderRadius: '15px',
                        // overflow: 'hidden',
                        width: '360px',
                        height: '500px',
                        borderRadius: '15px',
                        // background: '#ffffff',
                        overflow: 'hidden',
                      }}
                    >
                      {/* logo*/}
                      <div className="inst-top-row">
                        <div className="mt-3 inst-logo">
                          <Image
                            src="/tta_logo.jpg"
                            alt="Logo"
                            style={{ width: '150px', height: '150px' }}
                          />
                        </div>
                        <div className="py-2 inst-info">
                          <h5 className="m-0">INSTITUTE INFORMATION</h5>
                        </div>
                      </div>

                      <Card.Body className="p-3 mt-3 ins-card">
                        <div className="inst-data">
                          <p className="small text-muted text-start fw-semibold ">
                            {institutes?.name || 'This Institute'} is a premier
                            educational institution dedicated to excellence in
                            technical education.
                          </p>
                        </div>

                        <Row className="text-start ps-3 mt-3 inst-location student-bio">
                          <Col
                            xs={12}
                            className="d-flex align-items-center text-primary fs-6 bio-item"
                          >
                            <FaMapMarkerAlt className="me-2" />{' '}
                            <p className="m-0 small">
                              {' '}
                              <span className="fw-bold">Address : </span>{' '}
                              {institutes?.address || ''}{' '}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            className="d-flex align-items-center text-primary fs-6 bio-item"
                          >
                            <FaHashtag className="me-2" />
                            <p className="m-0 small">
                              {' '}
                              <span className="fw-bold">Pincode : </span>{' '}
                              {institutes?.pincode || ''}
                            </p>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>

            <div className="text-center mt-4 d-print-none">
              <Button variant="primary" onClick={handlePrint} className="me-2">
                Print ID Card
              </Button>
              <Button variant="success" onClick={handleDownloadBoth}>
                Download Image
              </Button>
            </div>
          </>
        ) : (
          <p>Loading ID Card...</p>
        )}
      </div>
    </>
  )
}
